
import { initFranchisesInCountries } from "./../js/franchisesInCountries/initFranchisesInCountries";

initFranchisesInCountries("franchises-in-countries");
